import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-4 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo & Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://static.readdy.ai/image/73ef2aa8b67f0b1ba51e6666fcef6024/d6b3d5294f1861bfb4676f2aec75193f.jpeg"
                alt="Phoenix Achievers Team LLC"
                className="h-10 w-10 object-contain rounded-lg"
              />
              <div>
                <h3 className="text-lg font-bold">Phoenix Achievers Team</h3>
                <p className="text-sm text-red-500 font-semibold">LLC</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Empowering Business Owners & Nonprofits to Succeed with professional consulting services across the globe.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-red-500">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-red-500">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  Business Registration
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  Government Contracts
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  Grant Writing
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  Web Design
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  Tax & Compliance
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-red-500">Contact Info</h4>
            <div className="space-y-2">
              <p className="text-gray-300 text-sm flex items-center">
                <i className="ri-phone-line mr-2 text-red-500"></i>
                <span>🇳🇬 09136628983</span>
              </p>
              <p className="text-gray-300 text-sm flex items-center">
                <i className="ri-phone-line mr-2 text-red-500"></i>
                <span>🇬🇧 +44 7577336876</span>
              </p>
              <p className="text-gray-300 text-sm flex items-center">
                <i className="ri-phone-line mr-2 text-red-500"></i>
                <span>🇺🇸 +1 469-738-0696</span>
              </p>
              <p className="text-gray-300 text-sm flex items-center">
                <i className="ri-mail-line mr-2 text-red-500"></i>
                <span>phoenixachieversteam@gmail.com</span>
              </p>
            </div>
          </div>
        </div>

        {/* Social Media & Professional Links */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            {/* Social Media Icons */}
            <div className="flex items-center space-x-4 mb-4 md:mb-0">
              <a 
                href="https://www.tiktok.com/@phoenixachieversteamllc" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-all duration-300 group"
              >
                <i className="ri-tiktok-line text-white group-hover:scale-110 transition-transform"></i>
              </a>
              <a 
                href="https://www.instagram.com/phoenixachieversteamllc/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-all duration-300 group"
              >
                <i className="ri-instagram-line text-white group-hover:scale-110 transition-transform"></i>
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61584440590340&sk=directory_links" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-all duration-300 group"
              >
                <i className="ri-facebook-line text-white group-hover:scale-110 transition-transform"></i>
              </a>
              <a 
                href="https://x.com/Phoenixteamllc" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-all duration-300 group"
              >
                <i className="ri-twitter-x-line text-white group-hover:scale-110 transition-transform"></i>
              </a>
              <a 
                href="https://www.instagram.com/phoenixachieversteamllc/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-all duration-300 group"
                title="Threads"
              >
                <i className="ri-at-line text-white group-hover:scale-110 transition-transform"></i>
              </a>
              <a 
                href="https://www.fiverr.com/users/abiodun136" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-all duration-300 group"
                title="Fiverr"
              >
                <i className="ri-briefcase-line text-white group-hover:scale-110 transition-transform"></i>
              </a>
              <a 
                href="https://www.upwork.com/agencies/1960314973182392391/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-all duration-300 group"
                title="Upwork Agency"
              >
                <i className="ri-building-line text-white group-hover:scale-110 transition-transform"></i>
              </a>
            </div>

            {/* Book Consultation Button */}
            <button
              onClick={() => window.open('https://wa.me/14697380696', '_blank')}
              className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap"
            >
              Book a Free Consultation
            </button>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            © 2026 Phoenix Achievers Team LLC. All Rights Reserved. | 
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-red-500 hover:text-red-400 ml-1"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
